import { useContext } from 'react';

import { DynamicAssessmentContext } from '../contexts/DynamicAssessmentContext';

/**
 * Whether `AssessmentContent` should render its trailing contact-support line.
 *
 * Unlike its siblings (`useDynamicAssessmentApiClient`, `useDynamicAssessmentHost`),
 * this does NOT throw when there's no provider: `AssessmentContent` is also rendered
 * directly by three onboarding web screens (`PhqGadScreen`, `PreDiabetesScreen`,
 * `LegacyAssignedScreenerFlow`) that predate `DynamicAssessmentProvider` and don't
 * mount one. Defaulting to `true` in that case preserves their existing behavior;
 * only a host that explicitly wires the provider can turn the line off.
 */
export function useShowContactSupport(): boolean {
  const value = useContext(DynamicAssessmentContext);
  return value?.showContactSupport ?? true;
}
